"use client";

import { useEffect } from "react";

export function LazyPostHogScript() {
	useEffect(() => {
		// Only run in browser
		if (typeof window === 'undefined') return;

		// Create and append script tag during browser runtime
		const script = document.createElement('script');
		script.src = 'https://app.posthog.com/static/array.js';
		script.async = true;
		script.onload = () => {
			if (window.posthog) {
				window.dispatchEvent(new CustomEvent('posthog-loaded'));
			}
		};
		document.head.appendChild(script);

		return () => {
			// Cleanup on unmount
			if (script.parentNode) {
				script.parentNode.removeChild(script);
			}
		};
	}, []);

	return null;
}